<template>
    <div class="detail-bg">
        <img :src="data" alt="" />
        <div class="go-back" v-if="isClose">
            <img
                src="@/assets/images/poster-close.png"
                class="close"
                @click="isClose = false"
                alt
            />
            <div class="go-back-btn" @click="goHome">
                <img src="@/assets/images/goBack.png" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
import { getData } from './request'
export default {
    data() {
        return {
            data: '',
            isClose: false
        }
    },
    created() {
        this.isClose = this.$route.query.isHome == 1
        getData({
            id: this.$route.query.id
        }).then(res => {
            const { data } = res
            console.log(data)
            this.data = data.img_url[0]
        })
    },
    methods: {
        goHome() {
            this.$router.go(-1)
        }
    }
}
</script>

<style scoped lang="scss">
.detail-bg {
    height: 100%;
    width: 100%;

    img {
        width: 100%;
    }
}
.go-back {
    position: fixed;
    right: 0.43rem;
    bottom: 8rem;
    .close {
        position: absolute;
        right: -0.3rem;
        top: -0.45rem;
        width: 0.8rem;
        height: 0.8rem;
    }
    .go-back-btn img {
        width: 2rem;
        height: 2rem;
    }
}
</style>
